module.exports = __webpack_public_path__ + "static/media/MESH_IEP_Background_Blue_v03.f4340865.png";